"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    checked: false,
    disabled: false,
};
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        toggle: function (style) { return (__assign({ width: 35, height: 20, backgroundColor: colors.Grey[500], borderRadius: 10, boxSizing: 'border-box', padding: 2, cursor: 'pointer' }, style)); },
        disabled: {
            backgroundColor: colors.Grey[300],
            cursor: 'not-allowed',
            pointerEvents: 'none',
        },
        thumb: {
            backgroundColor: colors.Grey[0],
            width: 16,
            height: 16,
            borderRadius: 8,
            transition: 'transform ease .2s',
        },
        checked: {
            backgroundColor: colors.Hannibal[600],
            '& $thumb': {
                transform: 'translateX(15px)',
            },
            '&$disabled': {
                backgroundColor: colors.Hannibal[300],
            },
        },
    });
});
var Toggle = function (_a) {
    var _b;
    var checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange, className = _a.className, style = _a.style;
    var styles = useStyles(style);
    return (react_1.default.createElement("div", { onClick: function () { return onChange && onChange(!checked); }, className: (0, classnames_1.default)(styles.toggle, !!className && className, (_b = {},
            _b[styles.checked] = checked,
            _b[styles.disabled] = disabled,
            _b)) },
        react_1.default.createElement("div", { className: styles.thumb })));
};
Toggle.defaultProps = defaultProps;
exports.default = Toggle;
//# sourceMappingURL=index.js.map